import { useState, useCallback } from 'react';
import { AxiosError } from 'axios';
import { Color } from '../types';
import api from '../services/bff';

export default function useColor(): {
  color: Color;
  setColor: (color: Color | undefined) => void;
  fetchColor: (cccid: string) => void;
  error: AxiosError;
  isLoading: boolean;
} {
  const [color, setColor] = useState<Color | undefined>();
  const [error, setError] = useState<AxiosError | undefined>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchColor = useCallback(async (cccid: string) => {
    const fetch = async (cccid: string) => {
      try {
        setIsLoading(true);
        const resp = await api.getColor(cccid);
        setColor(resp.data);
        setError(undefined);
      } catch (error) {
        setColor(undefined);
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };
    await fetch(cccid);
  }, []);

  return {
    color,
    setColor,
    fetchColor,
    error,
    isLoading,
  };
}
